import { Directive, ElementRef, booleanAttribute, inject, input } from '@angular/core';

import { HapticAction } from './haptic.models';
import { HapticsService } from './haptic.service';

@Directive({
    selector: '[msHaptics]',
    host: {
        '(click)': 'onInteraction()',
    },
})
export class HapticsDirective {
    private haptics = inject(HapticsService);
    private el = inject(ElementRef);

    readonly msHaptics = input.required<HapticAction>();
    readonly hapticsDisabled = input(false, { transform: booleanAttribute });

    onInteraction() {
        if (this.el.nativeElement.disabled || this.hapticsDisabled()) {
            return;
        }

        this.haptics.vibrate(this.msHaptics());
    }
}
